<template>
  <div class="flex">
      <div class="flex gap box">
        <img class="card-image" src="/images/visa.png" alt="Visa">
        <img class="card-image" src="/images/master-card.png" alt="Master Card">
      </div>
      <div class="box">
        <i class="el-icon-lock mr-5"></i>
        <span>Safe and secure 256-BIT SSL encrypted payment</span>
      </div>
  </div>
</template>

<script>
export default {

}
</script>

<style lang="scss" scoped>
    @import '@sass/_variables';
    
    .box {
        margin-left: 0;
        margin-right: 10px;
    }
    .box:last-child {
      margin-right: 0;
    }
    .card-image {
      width: 39px;
      height: 25px;
    }
    .gap {
      gap: 10px;
    }

</style>